import { use } from 'react';

import styled from '@emotion/styled';

import { SurveyThemeContext } from '@/shared-utilities';

const ThemedRoot = styled.div<{ themeStyles: Record<string, string> }>`
  ${(props) => props.themeStyles}
`;

interface Props {
  children: React.ReactNode;
}

/** Applies theme CSS variables so popup and hidden chat inherit branding. */
export default function ProjectUsabilityHandsFreeThemedRoot({
  children,
}: Props) {
  const { styles } = use(SurveyThemeContext);
  return (
    <ThemedRoot
      themeStyles={styles}
      data-test='project-usability-response-handsfree'
      className='fixed inset-0 mx-auto flex max-w-640 flex-col overflow-hidden bg-neutral-950'
    >
      {children}
    </ThemedRoot>
  );
}
